var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 217,
    viewBox: "0 0 221 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.056 120.305L-127.622 216.412C-127.622 216.412 -147.725 217.902 -148.989 196.296C-151.929 146.074 -106.955 31.344 3.73628 5.94659C114.427 -19.4508 196.684 48.548 217.062 89.3875C227.285 109.875 210.056 120.305 210.056 120.305Z",
    fill: "#F1F1F1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBottom);
export default __webpack_public_path__ + "static/media/circle_bottom.e1834944bd80b68300e937fd58e2ca88.svg";
export { ForwardRef as ReactComponent };